module.exports = __webpack_public_path__ + "img/trash-2.09152d3b.svg";